module.exports = __webpack_public_path__ + "static/media/16UNODC35.9d8af50f.jpg";